import { HYDRATE } from 'next-redux-wrapper';
import { isEqual } from 'lodash';
import { HotelContent } from '@model/iceberg/hotel-content/hotel-content';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum HotelActions {
  NAME = '@HOTEL',
  SET_HOTEL_PATH = '@HOTEL/SET_HOTEL_PATH'
}

export interface HotelState {
  path: string;
}

export const INITIAL_HOTEL_STATE: HotelState = {
  path: ''
};

export interface SetHotelProps {
  data?: HotelContent;
  shouldSendDataLayer: boolean;
}

const hotelSlice = createSlice({
  name: HotelActions.NAME,
  initialState: INITIAL_HOTEL_STATE,
  reducers: {
    setHotelPath: (state: HotelState, action: PayloadAction<any>) => {
      if (action.payload) {
        const path = action.payload.data?.place.hotel?.path || INITIAL_HOTEL_STATE.path;
        return { path };
      }
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state: any, action: any): any => {
      if (isEqual(state, INITIAL_HOTEL_STATE)) {
        const path = action.payload.hotel?.path;
        return path ? { path } : state;
      }
      return state;
    });
  }
});

export const { setHotelPath } = hotelSlice.actions;

export const hotelReducer = hotelSlice.reducer;
